export const appBuildAssetsDir = "/_nuxt3/"

export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"msapplication-config","content":"/meta/browserconfig-fressnapf-petmoji.xml"},{"name":"msapplication-TileColor","content":"#196428"},{"name":"theme-color","content":"#ffffff"}],"link":[{"rel":"preconnect","href":"https://assets.fressnapf.com"},{"rel":"preconnect","href":"https://media.os.fressnapf.com"},{"rel":"preconnect","href":"https://connect.facebook.net"},{"rel":"preconnect","href":"https://www.google.com"},{"rel":"preconnect","href":"https://www.gstatic.com","crossorigin":"anonymous"},{"rel":"icon","type":"image/x-icon","href":"/img/favicon-fressnapf-petmoji.ico"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/img/favicon-fressnapf-petmoji-32x32.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/img/favicon-fressnapf-petmoji-16x16.png"},{"rel":"apple-touch-icon","type":"image/png","sizes":"180x180","href":"/img/apple-touch-icon-fressnapf-petmoji.png"},{"rel":"mask-icon","type":"image/svg","color":"#196428","href":"/img/safari-pinned-tab-fressnapf-petmoji.svg"},{"rel":"manifest","crossorigin":"use-credentials","href":"/meta/manifest-fressnapf-petmoji.webmanifest"},{"rel":"preload","as":"font","type":"font/woff2","crossorigin":"anonymous","href":"/fonts/Icons/Icons.woff2"},{"rel":"preload","as":"font","type":"font/woff2","crossorigin":"anonymous","href":"/fonts/FNMZSkolar/FNMZSkolarSansLatinRegular.woff2"},{"rel":"preload","as":"font","type":"font/woff2","crossorigin":"anonymous","href":"/fonts/FNMZSkolar/FNMZSkolarSansLatinBold.woff2"},{"rel":"preload","as":"font","type":"font/woff2","crossorigin":"anonymous","href":"/fonts/FNMZSkolar/FNMZSkolarSansLatinExtraBold.woff2"}],"style":[{"children":"@font-face{font-family:\"Icons\";font-weight:400;font-style:normal;font-display:block;src:url('/fonts/Icons/Icons.woff2') format('woff2');}@font-face{font-family:\"FNMZSkolar\";font-weight:100;font-style:normal;font-display:swap;src:url('/fonts/FNMZSkolar/FNMZSkolarSansLatinRegular.woff2') format('woff2');}@font-face{font-family:\"FNMZSkolar\";font-weight:700;font-style:normal;font-display:swap;src:url('/fonts/FNMZSkolar/FNMZSkolarSansLatinBold.woff2') format('woff2');}@font-face{font-family:\"FNMZSkolar\";font-weight:900;font-style:normal;font-display:swap;src:url('/fonts/FNMZSkolar/FNMZSkolarSansLatinExtraBold.woff2') format('woff2');}@font-face{font-family:\"FnmzSkolarCompressed\";font-weight:100;font-style:normal;font-display:swap;src:url('/fonts/FNMZSkolar/FNMZSkolarSansLatinCompressedRegular.woff2') format('woff2');}@font-face{font-family:\"FnmzSkolarCompressed\";font-weight:700;font-style:normal;font-display:swap;src:url('/fonts/FNMZSkolar/FNMZSkolarSansLatinCompressedBold.woff2') format('woff2');}@font-face{font-family:\"FnmzSkolarCompressed\";font-weight:900;font-style:normal;font-display:swap;src:url('/fonts/FNMZSkolar/FNMZSkolarSansLatinCompressedExtraBold.woff2') format('woff2');}.font-icons{font-family:\"Icons\";}.font-fnmzskolar{font-family:\"FNMZSkolar\";}.font-fnmzskolar{font-family:\"FNMZSkolar\";}.font-fnmzskolar{font-family:\"FNMZSkolar\";}.font-fnmzskolarcompressed{font-family:\"FnmzSkolarCompressed\";}.font-fnmzskolarcompressed{font-family:\"FnmzSkolarCompressed\";}.font-fnmzskolarcompressed{font-family:\"FnmzSkolarCompressed\";}"}],"script":[{"children":"window.isNuxt3 = true;"},{"children":"var MboxArray = function (items) {\n  this.onChange = function () { };\n  this.items = items ? items : [];\n  this.firstPageLoad = true;\n\n  console.log('[storefront:mbox] Init')\n\n  this.push = function (item) {\n    console.log('[storefront:mbox] Push', item);\n    this.items.push(item);\n    this.onChange();\n  }\n\n  this.replace = function (items) {\n    console.log('[storefront:mbox] Replace', items);\n    this.items = items;\n    this.onChange();\n  }\n\n  this.clear = function () {\n    console.log('[storefront:mbox] Clear');\n    this.items = [];\n    this.onChange();\n  }\n\n  this.setOnChange = function (onChange, immediate = true) {\n    this.onChange = onChange;\n\n    if (immediate) {\n      this.onChange();\n    }\n  }\n\n  this.onPageLoaded = function () {\n    if (this.firstPageLoad) {\n      this.firstPageLoad = false;\n    } else {\n      this.clear();\n    }\n  }\n\n  return this;\n};\n\nwindow.mboxes = new MboxArray();\n"}],"noscript":[],"title":"FRESSNAPF","titleTemplate":"FRESSNAPF","viewport":"width=device-width, initial-scale=1"}

export const appPageTransition = {"name":"fade","mode":"out-in"}

export const appBaseURL = "/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true